import React, { useState } from 'react'
import { range, reverse } from '../../lib/ramda'
import { Tabs } from '../Tabs'
import { SchoolResultTabItem } from './SchoolResultTabItem'
import { STYLES } from '../../static/style'
import { IEditSchoolFormFields } from '../../types/SchoolAdmin.types'
const d = new Date()
const currentYear = d.getFullYear()
const YEARS = reverse(range(2011, currentYear))

interface ISchoolResultTabsProps {
  value?: IEditSchoolFormFields['results']
  onChange?: (a: any) => void
  name?: string
}

const SchoolResultTabs: React.FC<ISchoolResultTabsProps> = ({
  value,
  onChange,
  ...props
}) => {
  const [activeTabItemId, setActiveTabItemId] = useState(currentYear - 1)
  if (!value) {
    return null
  }
  const items = YEARS.map((year) => ({
    id: year,
    header: year,
    style:
      value[year] && !(value[year].examType as string)
        ? {
            backgroundColor: STYLES.COLOR_PALE_SKY_GRAY,
          }
        : {},
    content: (
      <SchoolResultTabItem
        results={
          value[year] ?? {
            examType: 'HSC',
          }
        }
        onChange={(v) => {
          if (onChange) {
            onChange({
              [year]: v,
            })
          }
        }}
      />
    ),
  }))

  return (
    <Tabs
      items={items}
      activeItemId={activeTabItemId}
      onItemHeaderClick={(id) => setActiveTabItemId(Number(id))}
    />
  )
}

export { SchoolResultTabs }
